<template>
  <div class="row">
    <div class="col-12">
      <div class="row row-cols-1 mt-5">
        <h1 class="mb-4">台灣虎航 S26(26夏季班表) 航班時間速查工具</h1>
        <div class="filter-form">
          <div class="row">
            <div class="col-md-3">
              <label for="tripType">行程類型</label>
              <select v-model="filters.tripType" class="form-select" id="tripType">
                <!-- <option value="">無限制</option> -->
                <option value="one-way" selected>單程</option>
                <!-- <option value="round-trip">來回</option>
                        <option value="multi-city">不同點</option> -->
              </select>
            </div>
            <div class="col-md-3">
              <label for="origin">出發地</label>
              <input v-model="filters.origin" type="text" class="form-control" id="origin" placeholder="輸入起點 (如 TPE)" />
            </div>
            <div class="col-md-3">
              <label for="destination">目的地</label>
              <input v-model="filters.destination" type="text" class="form-control" id="destination" placeholder="輸入終點 (如 NRT)" />
            </div>
            <div class="col-md-3">
              <label for="flightNumber">班次</label>
              <input v-model="filters.flightNumber" type="text" class="form-control" id="flightNumber" placeholder="輸入航班號 (如 IT200)" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <label for="departureTimeRange">出發時間範圍</label>
              <select v-model="filters.departureTimeRange" class="form-select" id="departureTimeRange">
                <option value="">不限範圍</option>
                <option v-for="range in timeRanges" :key="range.value" :value="range.value">{{ range.label }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <label for="arrivalTimeRange">抵達時間範圍</label>
              <select v-model="filters.arrivalTimeRange" class="form-select" id="arrivalTimeRange">
                <option value="">不限範圍</option>
                <option v-for="range in timeRanges" :key="range.value" :value="range.value">{{ range.label }}</option>
              </select>
            </div>
            <div class="col-md-6">
              <div class="form-text" id="basic-addon0">。出發地、目的地以 IATA 代碼顯示，如桃園機場代碼為 TPE，日本新千歲機場為 CTS，以此類推</div>
              <div class="form-text" id="basic-addon1">。本工具僅作為旅程規劃過程參考，實際航班時間仍以官網或官網訂位系統顯示為準</div>
              <div class="form-text fs-4" id="basic-addon2"><a href="https://www.tigerairtw.com/zh-TW/ready-to-go/flight-schedule" target="_blank">官網時刻表</a></div>
            </div>
            <!-- <div class="col-md-3">
                    <label for="dateRangeStart">日期範圍 (開始)</label>
                    <input v-model="filters.dateRangeStart" type="date" class="form-control" id="dateRangeStart">
                </div>
                <div class="col-md-3">
                    <label for="dateRangeEnd">日期範圍 (結束)</label>
                    <input v-model="filters.dateRangeEnd" type="date" class="form-control" id="dateRangeEnd">
                </div> -->
          </div>
          <button @click="resetFilters" class="btn btn-secondary mt-3">清除</button>
        </div>
        <div v-if="filters.tripType === 'round-trip' && filteredSchedules.length > 0 && !hasValidReturnFlights" class="alert alert-warning">注意：部分無匹配的回程航班，請檢查日期範圍或數據。</div>
        <div class="table-responsive">
          <table class="table table-bordered table-hover">
            <thead class="table-light">
              <tr>
                <th>出發地</th>
                <th>目的地</th>
                <th>班次</th>
                <th>出發時間</th>
                <th>抵達時間</th>
                <!-- <th>飛行時長</th> -->
                <th>週一</th>
                <th>週二</th>
                <th>週三</th>
                <th>週四</th>
                <th>週五</th>
                <th>週六</th>
                <th>週日</th>
                <th>運行日期</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(schedule, index) in filteredSchedules" :key="index">
                <td>{{ schedule.origin || "-" }}</td>
                <td>{{ schedule.destination || "-" }}</td>
                <td>{{ schedule.carrierCode ? schedule.carrierCode + schedule.flightNumber : "-" }}</td>
                <td>{{ formatTime(schedule.departureTime) }}</td>
                <td>{{ formatTime(schedule.arrivalTime) }}</td>
                <!-- <td>{{ schedule.durationInMinutes ? schedule.durationInMinutes + ' 分鐘' : '-' }}</td> -->
                <td><span :class="getDayClass(schedule.daysOfWeek, 'monday')"></span></td>
                <td><span :class="getDayClass(schedule.daysOfWeek, 'tuesday')"></span></td>
                <td><span :class="getDayClass(schedule.daysOfWeek, 'wednesday')"></span></td>
                <td><span :class="getDayClass(schedule.daysOfWeek, 'thursday')"></span></td>
                <td><span :class="getDayClass(schedule.daysOfWeek, 'friday')"></span></td>
                <td><span :class="getDayClass(schedule.daysOfWeek, 'saturday')"></span></td>
                <td><span :class="getDayClass(schedule.daysOfWeek, 'sunday')"></span></td>
                <td>{{ schedule.operationDateSummary || "-" }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="filteredSchedules.length === 0" class="alert alert-info">查無航班資訊</div>
      </div>
    </div>
    <!-- <template>
      <div class="ad-container">
        <Adsense data-ad-client="ca-pub-2965351057490665" data-ad-slot="5295990485" data-ad-format="auto" data-full-width-responsive="true"> </Adsense>
      </div>
    </template> -->
  </div>
</template>
<style>
  .table th,
  .table td {
    text-align: center;
    vertical-align: middle;
  }

  .filter-form {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
  }

  .filter-form .form-control,
  .filter-form .form-select {
    margin-bottom: 10px;
  }

  .day-circle-true,
  .day-circle-false {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
  }

  .day-circle-true {
    background-color: #28a745;
  }

  /* 綠色圓圈 */
  .day-circle-false {
    background-color: #dc3545;
  }

  /* 紅色圓圈 */
  .alert-warning {
    margin-top: 10px;
  }
</style>
<script>
  import flightData from "../../public/ITS26FlightsSchedule.js"
  export default {
    data() {
      return {
        schedules: [],
        filters: {
          tripType: "one-way",
          origin: "TPE",
          destination: "",
          flightNumber: "",
          departureTimeRange: "",
          arrivalTimeRange: "",
          dateRangeStart: "",
          dateRangeEnd: "",
        },
        timeRanges: [
          { label: "00:00 ~ 03:00", value: "00:00-03:00" },
          { label: "03:00 ~ 06:00", value: "03:00-06:00" },
          { label: "06:00 ~ 09:00", value: "06:00-09:00" },
          { label: "09:00 ~ 12:00", value: "09:00-12:00" },
          { label: "12:00 ~ 15:00", value: "12:00-15:00" },
          { label: "15:00 ~ 18:00", value: "15:00-18:00" },
          { label: "18:00 ~ 21:00", value: "18:00-21:00" },
          { label: "21:00 ~ 00:00", value: "21:00-00:00" },
        ],
        hasValidReturnFlights: true,
      }
    },
    computed: {
      filteredSchedules() {
        return this.schedules
          .filter((schedule) => {
            const isValid = schedule && typeof schedule === "object" && schedule.origin && schedule.destination && schedule.carrierCode && schedule.flightNumber && schedule.departureTime && schedule.arrivalTime && schedule.operationDateSummary && schedule.daysOfWeek && typeof schedule.daysOfWeek === "object"
            if (!isValid) console.warn("Invalid schedule filtered out:", schedule)
            return isValid
          })
          .filter((schedule) => {
            const originMatch = this.filters.origin ? schedule.origin?.toLowerCase().includes(this.filters.origin.toLowerCase()) : true
            const destinationMatch = this.filters.destination ? schedule.destination?.toLowerCase().includes(this.filters.destination.toLowerCase()) : true
            const flightNumberMatch = this.filters.flightNumber ? (schedule.carrierCode + schedule.flightNumber).toLowerCase().includes(this.filters.flightNumber.toLowerCase()) : true
            const departureTimeMatch = this.filters.departureTimeRange ? this.isTimeInRange(schedule.departureTime, this.filters.departureTimeRange) : true
            const arrivalTimeMatch = this.filters.arrivalTimeRange ? this.isTimeInRange(schedule.arrivalTime, this.filters.arrivalTimeRange) : true
            const dateRangeMatch = this.filters.dateRangeStart || this.filters.dateRangeEnd ? this.isDateInRange(schedule.operationDateSummary, this.filters.dateRangeStart, this.filters.dateRangeEnd) : true
            const tripTypeMatch = this.isTripTypeMatch(schedule)
            return originMatch && destinationMatch && flightNumberMatch && departureTimeMatch && arrivalTimeMatch && dateRangeMatch && tripTypeMatch
          })
      },
    },
    methods: {
      resetFilters() {
        this.filters = {
          tripType: "",
          origin: "",
          destination: "",
          flightNumber: "",
          departureTimeRange: "",
          arrivalTimeRange: "",
          dateRangeStart: "",
          dateRangeEnd: "",
        }
        this.hasValidReturnFlights = true
      },
      isTimeInRange(time, range) {
        if (!time || !range) return false
        const [start, end] = range.split("-")
        const timeHour = parseInt(time.split(":")[0], 10)
        const startHour = parseInt(start.split(":")[0], 10)
        const endHour = parseInt(end.split(":")[0], 10)
        if (range === "21:00-00:00") {
          return timeHour >= 21 || timeHour <= 0
        }
        return timeHour >= startHour && timeHour <= endHour
      },
      isDateInRange(operationDateSummary, startDate, endDate) {
        if (!operationDateSummary) return false
        const [flightStart, flightEnd] = operationDateSummary.split("-").map((date) => new Date(date))
        const userStart = startDate ? new Date(startDate) : new Date("1970-01-01")
        const userEnd = endDate ? new Date(endDate) : new Date("9999-12-31")
        return flightStart <= userEnd && flightEnd >= userStart
      },
      isTripTypeMatch(schedule) {
        if (!this.filters.tripType || this.filters.tripType === "one-way" || this.filters.tripType === "multi-city") {
          return true // 無限制、單程或不同點直接通過
        }
        if (this.filters.tripType === "round-trip") {
          if (!this.filters.origin || !this.filters.destination) {
            console.warn("Round-trip requires both origin and destination")
            this.hasValidReturnFlights = false
            return false
          }
          const hasReturn = this.schedules.some((returnSchedule) => {
            const isValidReturn = returnSchedule && returnSchedule.origin && returnSchedule.destination && returnSchedule.operationDateSummary && returnSchedule.origin.toLowerCase() === this.filters.destination.toLowerCase() && returnSchedule.destination.toLowerCase() === this.filters.origin.toLowerCase() && this.isDateInRange(returnSchedule.operationDateSummary, this.filters.dateRangeStart, this.filters.dateRangeEnd)
            if (isValidReturn) {
              console.log("Found valid return flight:", returnSchedule)
            } else {
              console.log("No valid return flight for:", schedule, "Checked:", returnSchedule)
            }
            return isValidReturn
          })
          if (!hasReturn) {
            console.log("No return flight found for schedule:", schedule)
            this.hasValidReturnFlights = false
          }
          return hasReturn
        }
        return true
      },
      getDayClass(daysOfWeek, day) {
        if (!daysOfWeek || typeof daysOfWeek[day] !== "boolean") {
          console.warn(`Invalid daysOfWeek for ${day}:`, daysOfWeek)
          return "day-circle-false" // 默認紅色圓圈
        }
        return daysOfWeek[day] ? "day-circle-true" : ""
      },
      formatTime(time) {
        if (!time || typeof time !== "string") return "-"
        return time.slice(0, 5) // 提取 HH:mm
      },
    },
    mounted() {
      if (typeof flightData === "undefined" || !flightData) {
        console.error("flightData is not defined or empty. Please check flights.js.")
        this.schedules = []
        return
      }
      if (!flightData.data || !Array.isArray(flightData.data)) {
        console.error("flightData.data is missing or not an array:", flightData)
        this.schedules = []
        return
      }
      try {
        this.schedules = flightData.data
          .flatMap((country) => {
            if (!country || !country.stationSchedules || !Array.isArray(country.stationSchedules)) {
              console.warn("Invalid country data:", country)
              return []
            }
            return country.stationSchedules
          })
          .flatMap((station) => {
            if (!station || !station.schedules || !Array.isArray(station.schedules)) {
              console.warn("Invalid station data:", station)
              return []
            }
            return station.schedules.filter((schedule) => {
              const isValid = schedule && typeof schedule === "object" && schedule.origin && schedule.destination && schedule.carrierCode && schedule.flightNumber && schedule.departureTime && schedule.arrivalTime && schedule.operationDateSummary && schedule.daysOfWeek && typeof schedule.daysOfWeek === "object"
              if (!isValid) console.warn("Invalid schedule in station:", schedule)
              return isValid
            })
          })
        console.log("Loaded schedules:", this.schedules)
        if (this.schedules.length === 0) {
          console.warn("No valid schedules loaded. Check JSON data structure.")
        }
      } catch (error) {
        console.error("Error loading schedules:", error)
        this.schedules = []
      }
    },
  }
</script>
